<script>
import { defineAsyncComponent } from 'vue';
import { componentStore } from '@common/componentStore/componentStore';
import { configStore } from '@common/configStore';
import mockConfig from './mockConfig';
import profileCard from './profileCard/profileCard';

let profileViewConfig = {
    cId: 'profileView',
    cType: 'profile-view',
    cTitle: 'Profile View',
    showInCmpList: false,
    cTemplate: `<div class="profile-view">
        <div class="profile-view-breadcrumb">
            <span class="profile-view-breadcrumb-back" @click="$emit('close')">
                {{ pspLabel }}
            </span>
            <span> > </span>
            <span>{{ recordId }}</span>
        </div>
        <div class="profile-view-body">
            <div
                v-for="tab in tabs"
                :key="tab.id"
                v-show="tab.id === activeTabId"
            >
                <div v-if="visitedTabs[tab.id]">
                    <ejs-dashboardlayout
                        :panels="allTabPositions[tab.id]"
                        :columns="6"
                        :allowDragging="false"
                        :created="tabCreatedHandlers[tab.id]"
                    ></ejs-dashboardlayout>
                    <div v-if="tabPanelReady[tab.id]">
                        <teleport
                            v-for="(card, index) in tab.cards"
                            :key="card.id"
                            :to="allTabPositions[tab.id][index].contentId"
                        >
                            <profile-card
                                :card="card"
                                :psp="psp"
                                :record-id="recordId"
                            ></profile-card>
                        </teleport>
                    </div>
                </div>
            </div>
        </div>
    </div>`
};

let profileViewCmp = {
    name: 'profile-view',
    components: {
        'ejs-dashboardlayout': defineAsyncComponent(() => import('@common/syncfusion/dashboardLayout')),
        'profile-card': profileCard,
    },
    props: {
        psp: { type: String, required: true }
        // record identity via mixin context props: contextVolId, contextOppId, contextOrgId, etc.
        // access as: this.volId, this.oppId, this.orgId, this.aeId
    },
    data() {
        return {
            mockData: {},
            activeTabId: null,
            visitedTabs: {},
            tabPanelReady: {},
        };
    },
    computed: {
        recordId() {
            const map = {
                vol: this.volId,
                opp: this.oppId,
                org: this.orgId,
                ae: this.aeId,
            };
            return map[this.psp] ?? null;
        },
        pspLabel() {
            return configStore.pspParentNamesPlural[this.psp] ?? this.psp;
        },
        tabs() {
            return this.mockData?.tabs ?? [];
        },
        allTabPositions() {
            const result = {};
            for (const tab of this.tabs) {
                result[tab.id] = tab.cards.map((card, index) => {
                    const panelId = `panel_content_${tab.id}_${index}`;
                    return {
                        id: card.id,
                        row: card.position.row,
                        col: card.position.col,
                        sizeX: card.position.sizeX,
                        sizeY: card.position.sizeY,
                        content: `<div id="${panelId}"></div>`,
                        contentId: `#${panelId}`,
                        positionIndex: index,
                    };
                });
            }
            return result;
        },
        tabCreatedHandlers() {
            const handlers = {};
            for (const tab of this.tabs) {
                const tabId = tab.id;
                handlers[tabId] = () => { this.tabPanelReady[tabId] = true; };
            }
            return handlers;
        },
    },
    methods: {
        onLoad() {
            // Replaces mockData with this.config when componentStore is hooked up
            this.mockData = mockConfig;
            if (this.tabs.length) {
                this.activeTabId = this.tabs[0].id;
                this.visitedTabs[this.tabs[0].id] = true;
            }
        },
        dashboardLayoutCreated(tabId) {
            this.tabPanelReady[tabId] = true;
        },
        selectTab(tabId) {
            this.activeTabId = tabId;
            this.visitedTabs[tabId] = true;
        },
    },
};

componentStore.initComponent(profileViewCmp, profileViewConfig);
export default profileViewCmp;
</script>
